<template>
  <div class="highlight-card">
    <div class="highlight-thumb">
      <img
        v-if="video.thumbnail"
        class="highlight-thumb-img"
        :src="video.thumbnail"
        :alt="video.title"
      />
      <video
        v-else-if="video.videoUrl"
        class="highlight-thumb-img"
        :src="`${video.videoUrl}#t=0.5`"
        preload="metadata"
        muted
        playsinline
        tabindex="-1"
      ></video>
      <div v-else class="highlight-thumb-placeholder"></div>

      <span class="gems-badge">
        <img src="/assets/event-highlights/gems.svg" alt="" />
        {{ video.points }}
      </span>

      <a
        class="highlight-play"
        href="javascript:void(0)"
        @click="$emit('play', video)"
      >
        <img src="/assets/event-highlights/play_btn.svg" alt="Play" />
      </a>
    </div>

    <h4 class="highlight-title">{{ video.title }}</h4>

    <div class="hl-meta">
      <div class="hl-meta-item">
        <img src="/assets/event-highlights/calender.svg" alt="" />
        <span>
          <small>Event Date</small>
          {{ video.eventDate }}
        </span>
      </div>
      <div class="hl-meta-item">
        <img src="/assets/event-highlights/clock.svg" alt="" />
        <span>
          <small>Expiry Date:</small>
          {{ video.expiryDate }}
        </span>
      </div>
    </div>

    <div class="highlight-actions">
      <a
        href="javascript:void(0)"
        class="hl-btn hl-btn--download"
        @click="$emit('download', video)"
      >
        <span>Download</span>
      </a>
      <a
        v-if="purchased"
        class="highlight-delete-btn"
        href="javascript:void(0)"
        aria-label="Delete"
        @click="$emit('delete', video)"
      >
        <img src="/assets/event-highlights/delete_btn.svg" alt="Delete" />
      </a>
    </div>
  </div>
</template>

<script>
import "@/assets/css/event-highlights.css";

export default {
  name: "HighlightCard",
  props: {
    video: {
      type: Object,
      required: true,
    },
    purchased: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.highlight-card {
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 24px;
}
.highlight-thumb {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #d9d9d9;
}
.highlight-thumb-img,
.highlight-thumb-placeholder {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;
}
/* .gems-badge visuals come from event-highlights.css; only the thumbnail
   placement is card-specific */
.highlight-thumb .gems-badge {
  position: absolute;
  top: 12px;
  left: 12px;
}
.highlight-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
}
.highlight-play img {
  width: 100%;
  height: 100%;
  display: block;
}
.highlight-title {
  font-size: 18px;
  font-weight: 700;
  margin: 14px 0 12px;
  color: #1a1a1a;
}
.hl-meta {
  margin-bottom: 16px;
}
/* on the card the two date items split the row ~50/50 (in the player modal
   they sit close-packed under the title, so this stays card-scoped) */
.hl-meta-item {
  flex: 1 1 0;
  min-width: 0;
}
.highlight-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.highlight-actions .hl-btn {
  flex: 1 1 auto;
  font-size: 18px;
}
.highlight-delete-btn {
  flex: 0 0 auto;
  height: 46px;
  aspect-ratio: 1 / 1;
  display: block;
}
.highlight-delete-btn img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
